<p>Global Search Result for "{{data.ValSearch}}"</p>
<!------------------------------------------------------------------------------------------------------------------------------------------------------------>
<mat-tab-group style="width: 1300px;">
    <mat-tab label="Student Result"> 

      <div>
        <table mat-table style="width: 100%;" [dataSource]="dataSource" matSort>
            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> No.</th>
                <td mat-cell *matCellDef="let element"> {{element.id}}</td>
            </ng-container>


            <!--Firstname Name Column -->
            <ng-container matColumnDef="firstname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
                <td mat-cell *matCellDef="let element"> {{element.firstname}} </td>
            </ng-container>

            <!-- Last name Column -->
            <ng-container matColumnDef="lastname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
                <td mat-cell *matCellDef="let element"> {{element.lastname}} </td>
            </ng-container>

            <!-- Student number Column -->
            <ng-container matColumnDef="studNum">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Student Number </th>
                <td mat-cell *matCellDef="let element"> {{element.studNum}} </td>
            </ng-container>

            <!-- Orientation Progress Column -->
            <ng-container matColumnDef="orientation_progress">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Orientation Progress</th>
              <td mat-cell *matCellDef="let element"> {{element.orientation_progress}} </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">Nothing was found for students </td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]" [length]="100" [pageSize]="10" style="margin-bottom: 5%;"></mat-paginator>
    </div>
    
    </mat-tab>
    <!------------------------------------------------------------------------------------------------------------------------------------------------------------>
    <mat-tab label="Orientation Videos"> 
    
      <div>
        <table mat-table style="width: 100%;" [dataSource]="dataSourceVideo" matSort>
            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> No.</th>
                <td mat-cell *matCellDef="let element"> {{element.id}}</td>
            </ng-container>


            <!--Firstname Name Column -->
            <ng-container matColumnDef="tittle">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
                <td mat-cell *matCellDef="let element"> {{element.tittle}} </td>
            </ng-container>

            <!-- Last name Column -->
            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Category </th>
                <td mat-cell *matCellDef="let element"> {{element.category}} </td>
            </ng-container>

            <!-- Student number Column -->
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let element"> {{element.type}} </td>
            </ng-container>

            <!-- Orientation Progress Column -->
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
              <td mat-cell *matCellDef="let element"> {{element.createdAt}} </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsVideo"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsVideo;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">Nothing was found for videos </td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]" [length]="100" [pageSize]="10" style="margin-bottom: 5%;"></mat-paginator>
    </div>
    
    </mat-tab>
    <!------------------------------------------------------------------------------------------------------------------------------------------------------------>
    <mat-tab label="Blogs"> 
    
      <div>
        <table mat-table style="width: 100%;" [dataSource]="dataSourceBlog" matSort>
            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> No.</th>
                <td mat-cell *matCellDef="let element"> {{element.id}}</td>
            </ng-container>


            <!--Firstname Name Column -->
            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
                <td mat-cell *matCellDef="let element"> {{element.title}} </td>
            </ng-container>

            <!-- Last name Column -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Description</th>
                <td mat-cell *matCellDef="let element"> {{element.description}} </td>
            </ng-container>

            <!-- Student number Column -->
            <ng-container matColumnDef="author">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Author</th>
                <td mat-cell *matCellDef="let element"> {{element.author}} </td>
            </ng-container>

            <!-- Orientation Progress Column -->
            <ng-container matColumnDef="subTittle">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub Title</th>
              <td mat-cell *matCellDef="let element"> {{element.subTittle}} </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsBlog"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsBlog;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">Nothing was found for Blogs </td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]"  [pageSize]="10" style="margin-bottom: 5%;"></mat-paginator>
    </div>

    </mat-tab>
  </mat-tab-group>
